import React, { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import IconMai from "@mdi/react";
import { mdiPencilCircle, mdiDelete } from "@mdi/js";
import EmptyModel from "../../../components/modal/emptyModal";
import Input from "../../../components/textfield/input";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const StockCategory = () => {
  const { confirm } = Modal;
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const [typeNameStock, setTypeNameStock] = useState<string>("");
  const [codeTypeStock, setCodeTypeStock] = useState<string>("");
  const [stockId, setStockId] = useState();
  const [state, setState] = useState<any>({
    listitem: [],
  });

  const columns = [
    {
      title: "",
    },
    {
      title: "รหัสประเภทสต็อก",
    },
    {
      title: "ชื่อประเภทสต็อก",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];
  const data = [
    {
      _id: 1,
      codestock: "FG",
      namestock: "Finished Goods",
      date: "18-01-2564",
    },
    {
      _id: 2,
      codestock: "MA",
      namestock: "M A",
      date: "18-01-2564",
    },
    {
      _id: 3,
      codestock: "RA",
      namestock: "Regulatory Affairs",
      date: "20-01-2564",
    },
  ];

  const getAPIs = () => {
    setState({ ...state, listitem: data });
  };

  const getDataOne = (item: any) => {
    setStockId(item._id);
    setCodeTypeStock(item.codestock);
    setTypeNameStock(item.namestock);
  };

  const creatData = () => {
    setIsOpen(false);
    return onHandledata({
      codestock: codeTypeStock,
      namestock: typeNameStock,
    });
  };

  const updateData = (id: number) => {
    console.log("UPDATE DATA SUCCESS => ", id);
    setIsOpen(false);
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // console.log("OK");
        // deleteData(id);
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  }

  const setChar = () => {
    setTypeNameStock("");
    setCodeTypeStock("");
  };

  function onHandledata(data: any) {
    const listitem = state.listitem;
    listitem.push(data);

    setState({ ...state, listitem: listitem });
  }

  function onClose() {
    setIsOpen(false);
  }

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title="STOCK CATEGORY" />
      <EmptyModel show={isOpen} onClose={onClose} width="65%">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <h4>สร้างประเภทสต๊อก</h4>

          <div className="row justify-center  mt-20">
            <Input
              className="col-8"
              title="ชื่อประเภทสต๊อก"
              placeholder=""
              value={typeNameStock}
              onChange={(e) => {
                setTypeNameStock(e.target.value);
              }}
            />
          </div>
          <div className="row justify-center mt-20">
            <Input
              className="col-8"
              title="รหัสประเภทสต๊อก"
              placeholder=""
              value={codeTypeStock}
              onChange={(e) => {
                setCodeTypeStock(e.target.value);
              }}
            />
          </div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก"
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล"
              onClick={() => {
                stockId ? updateData(stockId) : creatData();
              }}
            />
          </div>
        </div>
      </EmptyModel>
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="สร้างประเภทสต๊อก"
            onClick={() => {
              setIsOpen(true);
              setChar();
            }}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {state.listitem.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="15%">{item.codestock}</TableColumn>
                <TableColumn width="50%">{item.namestock}</TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      setIsOpen(true);
                      getDataOne(item);
                    }}
                  >
                    <IconMai path={mdiPencilCircle} size="30" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="5%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.namestock);
                  }}
                >
                  <IconMai path={mdiDelete} size="25" color="#FF6760"></IconMai>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default StockCategory;
